// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".position-absolute[data-v-91b4f026]{position:absolute}.fixed-bar[data-v-91b4f026]{top:64px}.fixed-bar[data-v-91b4f026],.fixed-bar-small[data-v-91b4f026]{position:fixed;left:0;bottom:0;right:0;z-index:2}.fixed-bar-small[data-v-91b4f026]{top:56px}", ""]);
// Exports
module.exports = exports;
